<template>
    <div class="stock_detail">
        <div class="detail_header">
            <div class="back_btn" @click="goBack">
                <van-icon name="arrow-left" size="24" />
            </div>
            <span class="detail_title">{{type === 'product' ? '产品' : '物料'}}详情</span>
            <div class="header_actions">
                <van-icon name="edit" size="22" color="#4E89FF" @click="openEdit" />
            </div>
        </div>

        <div class="detail_content" v-if="detail.id">
            <!-- 操作按钮 -->
            <div class="ship_action_bar">
                <van-button v-if="type === 'product' && userInfo.stock_user_view_power != 1" type="default" size="small" round @click="showMaterialsPopup = true" :disabled="productMaterials.length === 0">
                    <van-icon name="cluster-o" /> 物料{{productMaterials.length > 0 ? '(' + productMaterials.length + ')' : ''}}
                </van-button>
                <van-button type="danger" size="small" icon="logistics" round @click="openShipment">
                    发货
                </van-button>
            </div>
            <!-- 基本信息 -->
            <div class="info_card">
                <div class="info_imgs">
                    <van-swipe :autoplay="3000" indicator-color="#4E89FF">
                        <van-swipe-item v-for="(img, index) in imgList" :key="index">
                            <img :src="img" @click="previewImg(img)" @error="handleImgError">
                        </van-swipe-item>
                    </van-swipe>
                    <div class="img_tag">{{type === 'product' ? '产品' : '物料'}}</div>
                </div>
                
                <div class="info_main">
                    <div class="info_name">{{detail.name}}</div>
                    <div class="info_code">编码: {{detail.code}}</div>
                    <div class="info_stock">
                        <div class="stock_num">
                            <span class="num">{{detail.stock_num}}</span>
                            <span class="unit">件</span>
                        </div>
                        <div class="stock_label">库存总数</div>
                    </div>
                    <!-- 各仓库库存明细 -->
                    <div class="warehouse_stock_list" v-if="detail.stock_num_info && detail.stock_num_info.length">
                        <div class="wh_stock_item" v-for="(wh, idx) in detail.stock_num_info" :key="idx">
                            <span class="wh_stock_name">{{wh.stock_name}}</span>
                            <span class="wh_stock_num" :class="{low: wh.StockNum <= 0}">{{wh.StockNum}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 二维码区域 -->
            <div class="detail_section" v-if="detail.qrcode_key || detail.code">
                <div class="section_title">产品二维码</div>
                <div class="qrcode_area">
                    <div class="qrcode_img">
                        <img v-if="qrCodeDataUrl" :src="qrCodeDataUrl" alt="二维码" @error="handleImgError">
                        <van-loading v-else type="spinner" size="40px" />
                    </div>
                    <div class="qrcode_info">
                        <!-- <span class="code">{{detail.code}}</span> -->
                        <span class="name">{{detail.name}}</span>
                    </div>
                    <div class="qrcode_actions">
                        <van-button type="primary" size="small" icon="printer" @click="printLabel">打印标签</van-button>
                    </div>
                </div>
            </div>

            <!-- 详细信息 -->
            <div class="detail_section">
                <div class="section_title">详细信息</div>
                <div class="section_content">
                    <div class="info_row">
                        <span class="label">介绍</span>
                        <span class="value">{{detail.intro || '-'}}</span>
                    </div>
                    <!-- 物料特有的采购信息 -->
                    <template v-if="type === 'material'">
                        <div class="info_row">
                            <span class="label">采购链接</span>
                            <a class="value link" :href="detail.purchase_link" target="_blank" v-if="detail.purchase_link">
                                点击查看 <van-icon name="link" size="16" />
                            </a>
                            <span class="value" v-else>-</span>
                        </div>
                        <div class="info_row">
                            <span class="label">联系电话</span>
                            <a class="value link" :href="'tel:' + detail.purchase_telphone" v-if="detail.purchase_telphone">
                                {{detail.purchase_telphone}} <van-icon name="phone" size="16" />
                            </a>
                            <span class="value" v-else>-</span>
                        </div>
                    </template>
                </div>
            </div>

            <!-- 库存统计 -->
            <div class="detail_section" v-if="userInfo.stock_user_view_power != 1">
                <div class="section_title">库存统计</div>
                <div class="stock_stats">
                    <div class="stats_group">
                        <div class="group_title">今日</div>
                        <div class="stats_grid">
                            <div class="stat_item">
                                <span class="stat_value in">+{{detail.today_in_num || 0}}</span>
                                <span class="stat_label">入库</span>
                            </div>
                            <div class="stat_item">
                                <span class="stat_value out">-{{detail.today_out_num || 0}}</span>
                                <span class="stat_label">出库</span>
                            </div>
                            <div class="stat_item">
                                <span class="stat_value shipment">{{detail.today_shipment_num || 0}}</span>
                                <span class="stat_label">发货</span>
                            </div>
                        </div>
                    </div>
                    <div class="stats_divider"></div>
                    <div class="stats_group">
                        <div class="group_title">历史累计</div>
                        <div class="stats_grid">
                            <div class="stat_item">
                                <span class="stat_value in">+{{detail.history_in_num || 0}}</span>
                                <span class="stat_label">入库</span>
                            </div>
                            <div class="stat_item">
                                <span class="stat_value out">-{{detail.history_out_num || 0}}</span>
                                <span class="stat_label">出库</span>
                            </div>
                            <div class="stat_item">
                                <span class="stat_value shipment">{{detail.history_shipment_num || 0}}</span>
                                <span class="stat_label">发货</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 关联物料 -->
            <!-- <div class="detail_section" v-if="type === 'product' && productMaterials.length > 0">
                <div class="section_title">
                    关联物料
                    <span class="count">共{{productMaterials.length}}种</span>
                </div>
                <div class="material_list">
                    <div class="material_item" v-for="item in productMaterials" :key="item.id" @click="toMaterialDetail(item.material_id || item.id)">
                        <div class="material_info">
                            <div class="material_name">{{item.material_name || '-'}}</div>
                            <div class="material_num">配比: {{item.need_num || item.quantity || 0}}件</div>
                        </div>
                        <div class="material_arrow">
                            <van-icon name="arrow" size="16" color="#ccc" />
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- 最近出入库记录 -->
            <div class="detail_section" v-if="userInfo.stock_user_view_power != 1">
                <div class="section_title">
                    最近出入库记录
                    <span class="more" @click="toAllRecords">查看全部 <van-icon name="arrow" size="16" /></span>
                </div>
                <div class="record_list">
                    <div class="record_item" v-for="item in stockRecords.slice(0, 2)" :key="item.id">
                        <div class="record_icon" :class="item.in_out">
                            <van-icon :name="item.in_out === 'in' ? 'arrow-down' : 'arrow-up'" :color="item.in_out === 'in' ? '#4CAF50' : '#F44336'" size="24" />
                        </div>
                        <div class="record_info">
                            <div class="record_title">{{item.record_name}} - {{item.in_out === 'in' ? '入库' : '出库'}} {{item.apply_num}}件</div>
                            <div class="record_time">{{item.create_time | formatTime}}</div>
                            <div class="record_user" v-if="item.apply_user_name">申请人: {{item.apply_user_name}}</div>
                        </div>
                        <div class="record_status" :class="item.sure_user_id ? 'status_1' : 'status_0'">
                            {{item.sure_user_id ? '已确认' : '待确认'}}
                        </div>
                    </div>
                    <div class="no_record" v-if="stockRecords.length === 0">
                        <img src="/static/imgs/no_data.jpg" alt="">
                        <span>暂无记录</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 加载中 -->
        <div class="loading_state" v-else>
            <van-loading type="spinner" size="40px" />
            <span>加载中...</span>
        </div>

        <!-- 发货弹窗 -->
        <shipment-dialog
            v-model="showShipmentDialog"
            :shipment-type="type"
            :preselected-items="shipmentPreselected"
            :user-info="userInfo"
            @success="onShipmentSuccess"
        />

        <!-- 关联物料弹窗 -->
        <van-popup v-model="showMaterialsPopup" position="bottom" round :style="{ maxHeight: '70vh' }">
            <div class="materials_popup">
                <div class="materials_popup_header">
                    <span>关联物料</span>
                    <van-icon name="cross" @click="showMaterialsPopup = false" />
                </div>
                <div class="materials_popup_body" v-if="productMaterials.length > 0">
                    <div class="material_item" v-for="item in productMaterials" :key="item.id" @click="toMaterialDetail(item.material_id || item.id)">
                        <div class="material_info">
                            <div class="material_name">{{item.material_name || '-'}}</div>
                            <div class="material_num">配比: {{item.need_num || item.quantity || 0}}件</div>
                        </div>
                        <van-icon name="arrow" size="16" color="#ccc" />
                    </div>
                </div>
                <div class="materials_popup_empty" v-else>
                    <span>暂无关联物料</span>
                </div>
            </div>
        </van-popup>

        <!-- 打印预览弹窗 -->
        <van-popup v-model="showPrintPreview" round closeable style="width: 90%; max-height: 85vh;">
            <div class="image_preview_dialog">
                <div class="preview_title">标签预览</div>
                <div class="preview_image_container">
                    <img :src="previewImageUrl" alt="标签预览" class="preview_image" id="previewImage" v-if="previewImageUrl" @error="handleImgError">
                    <van-loading v-else type="spinner" size="40px" />
                </div>
                
                <!-- 打印提示 -->
                <div class="preview_tips">
                    <p><strong>打印步骤：</strong></p>
                    <p>1. 点击"打开微打"跳转到下载页</p>
                    <p>2. 下载安装微打APP</p>
                    <p>3. 长按上方图片保存到相册</p>
                    <p>4. 打开微打APP选择图片打印</p>
                </div>
                
                <div class="preview_actions">
                    <van-button type="default" block @click="showPrintPreview = false">关闭</van-button>
                    <van-button 
                        type="primary" 
                        block 
                        @click="openInBrowser" 
                    >打开微打</van-button>
                </div>
            </div>
        </van-popup>

        <!-- 编辑弹窗 -->
        <van-popup v-model="showEdit" position="bottom" round :style="{ height: '88%' }" closeable>
            <div class="edit_popup">
                <div class="edit_header">
                    <span class="edit_title">编辑{{type === 'product' ? '产品' : '物料'}}</span>
                </div>
                <div class="edit_scroll">
                    <!-- 图片区域 -->
                    <div class="edit_photos">
                        <div class="photo_label">图片（可上传多张）</div>
                        <div class="photo_grid">
                            <div class="photo_item" v-for="(img, idx) in editImgList" :key="idx">
                                <img :src="img" />
                                <div class="photo_del" @click="removeEditImg(idx)">
                                    <van-icon name="cross" size="14" color="#fff" />
                                </div>
                            </div>
                            <div class="photo_add" @click="triggerEditImgUpload">
                                <van-icon name="plus" size="32" color="#4E89FF" />
                                <span>添加图片</span>
                            </div>
                        </div>
                        <input ref="editImgInput" type="file" accept="image/*" multiple style="display:none" @change="handleEditImgSelect" />
                    </div>
                    <!-- 基本信息 -->
                    <van-cell-group class="edit_form">
                        <van-field v-model="editForm.name" label="名称" placeholder="请输入名称" required />
                        <van-field v-model="editForm.code" label="编码" placeholder="请输入编码" required />
                        <van-field v-model="editForm.intro" label="介绍" type="textarea" rows="3" placeholder="选填" autosize />
                        <!-- 物料特有字段 -->
                        <template v-if="type === 'material'">
                            <van-field v-model="editForm.purchase_link" label="采购链接" placeholder="选填" />
                            <van-field v-model="editForm.purchase_telphone" label="采购电话" placeholder="选填" />
                        </template>
                    </van-cell-group>
                </div>
                <div class="edit_footer">
                    <van-button type="primary" block round :loading="editSaving" loading-text="保存中..." @click="saveEdit">
                        保存修改
                    </van-button>
                </div>
            </div>
        </van-popup>

        <!-- 隐藏的标签打印区域 -->
        <div class="print_label_hidden">
            <div class="label_preview" id="printArea" ref="printArea">
                <!-- Logo -->
                <div class="preview_logo">
                    <img src="/static/imgs/icon.png" alt="LOGO" />
                </div>
                <!-- 类型标签 -->
                <div class="preview_type">{{type === 'product' ? '产品' : '物料'}}</div>
                <!-- 顶部分隔线 -->
                <div class="preview_divider top"></div>
                <!-- 主体内容 -->
                <div class="preview_body">
                    <div class="preview_info">
                        <div class="preview_name" :class="getNameSizeClass(detail.name)">{{detail.name}}</div>
                        <div class="preview_code" :class="getCodeSizeClass(detail.code)">{{detail.code}}</div>
                        <div class="preview_hint">扫描右侧二维码溯源</div>
                    </div>
                    <div class="preview_qr">
                        <img :src="qrCodeDataUrl" alt="二维码" v-if="qrCodeDataUrl" @error="handleImgError" />
                    </div>
                </div>
                <!-- 底部分隔线 -->
                <div class="preview_divider bottom"></div>
                <!-- 时间 -->
                <div class="preview_time">{{currentTime}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import studio_api from '@/api/teaching_studio_teaching_studio_api.js'
import studio_tool_api from '@/api/teaching_studio_tool.js'
import until from '@/api/until.js'
import QRCode from 'qrcode'
import html2canvas from 'html2canvas'
import ShipmentDialog from '@/components/ShipmentDialog.vue'
import { formatIotmaxTimestamp, getIotmaxFormAuth, parseIotmaxImageList } from '@/utils/iotmaxStock.js'

export default {
    name: 'StockDetail',
    components: {
        ShipmentDialog
    },
    data() {
        return {
            type: '', // product | material
            id: null,
            qrcode_key: '', // 二维码key（扫码跳转用）
            detail: {},
            imgList: [],
            stockRecords: [],
            qrCodeDataUrl: '', // 二维码图片
            productMaterials: [], // 产品关联的物料
            // 打印预览
            showPrintPreview: false,
            previewImageUrl: '',
            // 发货弹窗
            showShipmentDialog: false,
            showMaterialsPopup: false,
            userInfo: {},
            shipmentPreselected: [],
            // 编辑
            showEdit: false,
            editSaving: false,
            editForm: {
                name: '',
                code: '',
                intro: '',
                purchase_link: '',
                purchase_telphone: ''
            },
            editImgList: [],
            uploadConfig: { host: '', policy: '', accessid: '', signature: '', dir: '' }
        }
    },
    filters: {
        formatTime(timestamp) {
            return formatIotmaxTimestamp(timestamp)
        },
        statusText(status) {
            const map = {
                0: '待审核',
                1: '已通过',
                2: '已拒绝'
            }
            return map[status] || '未知'
        },
        getFirstImg(imgs) {
            return parseIotmaxImageList(imgs)[0] || '/static/imgs/no_img.png'
        }
    },
    computed: {
        currentTime() {
            return this.getCurrentTime()
        }
    },
    // 当路由参数变化时复用组件，需要重新加载数据
    beforeRouteUpdate(to, from, next) {
        this.type = to.query.type
        this.id = to.query.id
        this.qrcode_key = to.query.qrcode_key
        
        // 重置数据
        this.detail = {}
        this.imgList = []
        this.stockRecords = []
        this.qrCodeDataUrl = ''
        this.productMaterials = []
        this.previewImageUrl = ''
        
        document.title = this.type === 'product' ? '产品详情' : '物料详情'
        
        // 重新加载数据
        if (this.qrcode_key && !this.id) {
            this.getDetailByQrcode()
        } else {
            this.getDetail()
            this.getStockRecords()
            if (this.type === 'product') {
                this.getProductMaterials()
            }
        }
        
        next()
    },
    mounted() {
        this.initPage()
    },
    methods: {
        // 返回按钮逻辑：如果有历史记录则返回，否则跳转到对应列表页
        goBack() {
            if (window.history.length > 1) {
                this.$router.back()
            } else {
                // 从模板消息等外部链接进入，没有历史记录，跳转到对应列表
                if (this.type === 'material') {
                    this.$router.replace('/warehouse/material')
                } else {
                    this.$router.replace('/warehouse/product')
                }
            }
        },

        // 获取当前用户信息
        async getUserInfo() {
            try {
                let data = await studio_api.Teaching_studio_apiMemberLogin_userGet({ app_id: this.$root.app_id })
                if (data.errcode == 0) {
                    this.userInfo = data.other
                }
            } catch(e) {}
        },
        // 图片加载失败处理
        handleImgError(e) {
            // 隐藏图片，显示占位背景
            e.target.style.display = 'none'
            e.target.parentElement.classList.add('img_error')
        },
        // 初始化页面
        async initPage() {
            this.type = this.$route.query.type
            this.id = this.$route.query.id
            this.qrcode_key = this.$route.query.qrcode_key
            document.title = this.type === 'product' ? '产品详情' : '物料详情'
            await this.getUserInfo()
            
            // 如果有 qrcode_key 但没有 id，通过 qrcode_key 查询
            if (this.qrcode_key && !this.id) {
                this.getDetailByQrcode()
            } else {
                this.getDetail()
                this.getStockRecords()
                if (this.type === 'product') {
                    this.getProductMaterials()
                }
            }
        },

        // 通过二维码key获取详情（扫码跳转用）
        async getDetailByQrcode() {
            this.$toast.loading({ message: '加载中...' })
            
            // 先尝试查询产品
            let res = await studio_api.Teaching_studio_apiIotmaxProductDetail_by_qrcodeGet({ 
                app_id: this.$root.app_id, 
                qrcode_key: this.qrcode_key 
            })
            
            if (res.errcode == 0 && res.other) {
                this.type = 'product'
                this.detail = res.other
                this.id = this.detail.id
            } else {
                // 再尝试查询物料
                res = await studio_api.Teaching_studio_apiIotmaxMaterialDetail_by_qrcodeGet({ 
                    app_id: this.$root.app_id, 
                    qrcode_key: this.qrcode_key 
                })
                
                if (res.errcode == 0 && res.other) {
                    this.type = 'material'
                    this.detail = res.other
                    this.id = this.detail.id
                } else {
                    this.$toast('未找到对应的产品或物料')
                    this.$toast.clear()
                    return
                }
            }
            
            this.$toast.clear()
            document.title = this.type === 'product' ? '产品详情' : '物料详情'
            
            this.imgList = parseIotmaxImageList(this.detail.imgs)
            
            // 生成二维码
            await this.generateQRCode()
            
            // 获取出入库记录
            this.getStockRecords()
            if (this.type === 'product') {
                this.getProductMaterials()
            }
        },

        // 获取详情
        async getDetail() {
            this.$toast.loading({ message: '加载中...' })
            
            let api = this.type === 'product' 
                ? studio_api.Teaching_studio_apiIotmaxProductDetailGet 
                : studio_api.Teaching_studio_apiIotmaxMaterialDetailGet
            
            let res = await api({ app_id: this.$root.app_id, id: this.id })
            
            this.$toast.clear()
            
            if (res.errcode == 0) {
                this.detail = res.other || {}
                this.imgList = parseIotmaxImageList(this.detail.imgs)
                // 生成二维码
                await this.generateQRCode()
            }
        },

        // 获取出入库记录
        async getStockRecords() {
            let res = await studio_api.Teaching_studio_apiIotmaxStock_out_applyListGet({
                app_id: this.$root.app_id,
                apply_type: this.type,
                record_id: this.id,
                page: 1,
                each_page: 5
            })
            
            if (res.errcode == 0 && res.other) {
                // 接口返回格式: {count: x, list: [...]}
                this.stockRecords = res.other.list || []
            }
        },

        // 获取产品关联物料
        async getProductMaterials() {
            let res = await studio_api.Teaching_studio_apiIotmaxProduct_material_relationList_by_productGet({
                app_id: this.$root.app_id,
                product_id: this.id
            })
            
            if (res.errcode == 0 && res.other) {
                // API返回格式: other是数组
                let list = Array.isArray(res.other) ? res.other : []
                
                // 处理数据，确保有 material_id 字段
                this.productMaterials = list.map(item => {
                    // API 可能返回 material_id 或 id，优先使用 material_id
                    return {
                        ...item,
                        material_id: item.material_id || item.id
                    }
                })
            } else {
                this.productMaterials = []
            }
        },

        // 跳转到物料详情
        toMaterialDetail(materialId) {
            if (!materialId) {
                this.$toast('物料ID为空，无法跳转')
                console.error('物料ID为空')
                return
            }
            this.$router.push({
                path: '/warehouse/detail',
                query: { type: 'material', id: materialId }
            }).catch(err => {
                console.error('路由跳转失败:', err)
                this.$toast('跳转失败')
            })
        },

        // 计算名称字体大小
        getNameSizeClass(name) {
            const len = name?.length || 0
            if (len > 20) return 'name-xsmall'
            if (len > 14) return 'name-small'
            if (len > 8) return 'name-medium'
            return 'name-large'
        },
        
        // 计算编码字体大小
        getCodeSizeClass(code) {
            const len = code?.length || 0
            if (len > 14) return 'code-small'
            return 'code-normal'
        },

        // 获取当前时间
        getCurrentTime() {
            let now = new Date()
            return `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')} ${String(now.getHours()).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}:${String(now.getSeconds()).padStart(2,'0')}`
        },

        // 打印标签 - 使用 html2canvas 生成图片
        async printLabel() {
            if (!this.qrCodeDataUrl) {
                this.$toast('二维码生成中，请稍后再试')
                return
            }
            
            this.$toast.loading({ message: '生成标签中...', forbidClick: true, duration: 0 })
            
            try {
                const imageDataUrl = await this.generateLabelImage()
                this.$toast.clear()
                
                this.previewImageUrl = imageDataUrl
                this.showPrintPreview = true
            } catch (error) {
                console.error('生成标签失败', error)
                this.$toast('生成标签失败')
            }
        },

        // 生成标签图片
        async generateLabelImage() {
            const element = document.getElementById('printArea')
            if (!element) throw new Error('打印区域不存在')
            
            await this.$nextTick()
            await new Promise(resolve => setTimeout(resolve, 100))
            
            const canvas = await html2canvas(element, {
                scale: 4,
                backgroundColor: '#fff',
                useCORS: true,
                allowTaint: true,
                logging: false
            })
            
            return canvas.toDataURL('image/png', 1.0)
        },

        // 下载预览图片
        downloadPreviewImage() {
            if (!this.previewImageUrl) return
            
            if (this.isIOS()) {
                this.$toast('iOS请长按图片选择"存储图像"保存')
                return
            }
            
            try {
                const link = document.createElement('a')
                link.download = `标签_${this.detail.code || 'detail'}_${Date.now()}.png`
                link.href = this.previewImageUrl
                link.target = '_blank'
                link.style.display = 'none'
                
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                
                this.$toast.success('图片已下载')
            } catch (e) {
                console.error('下载失败', e)
                this.$toast('下载失败，请长按图片保存')
            }
        },

        // 检测是否为iOS
        isIOS() {
            return /iPad|iPhone|iPod/i.test(navigator.userAgent)
        },

        // 检测是否为Android
        isAndroid() {
            return /Android/i.test(navigator.userAgent)
        },

        // 调起微打APP（已废弃，保留代码备用）
        launchWeidaApp() {
            const isIOS = this.isIOS()
            const isAndroid = this.isAndroid()
            
            // 在微信中显示引导
            if (this.isWechat()) {
                this.showBrowserOpenGuide(isIOS, isAndroid)
                return
            }
            
            // 尝试调起APP，同时检测是否成功
            let appOpened = false
            const checkVisibility = () => {
                if (document.hidden || document.webkitHidden) {
                    appOpened = true
                }
            }
            
            document.addEventListener('visibilitychange', checkVisibility)
            document.addEventListener('webkitvisibilitychange', checkVisibility)
            
            // 尝试打开微打APP
            if (isIOS) {
                // iOS: 尝试 Universal Link 或 URL Scheme
                window.location.href = 'https://www.detonger.com/app'
                setTimeout(() => {
                    window.location.href = 'detonger://'
                }, 100)
            } else if (isAndroid) {
                // Android: 尝试 Intent
                window.location.href = 'intent://print#Intent;scheme=detonger;package=com.detonger.weida;end'
            }
            
            // 延迟检测是否成功打开
            setTimeout(() => {
                document.removeEventListener('visibilitychange', checkVisibility)
                document.removeEventListener('webkitvisibilitychange', checkVisibility)
                
                if (!appOpened && !document.hidden) {
                    // APP未打开，显示下载提示
                    this.showWeidaDownloadGuide(isIOS, isAndroid)
                }
            }, 1500)
        },

        // 显示微打下载引导
        showWeidaDownloadGuide(isIOS, isAndroid) {
            const downloadUrl = isIOS 
                ? 'https://apps.apple.com/cn/app/%E5%BE%AE%E6%89%93/id1548923373'
                : 'https://www.detonger.com/download'
            
            this.$dialog.confirm({
                title: '未检测到微打APP',
                message: '打印标签需要安装【微打】APP\n\n您可以选择：\n1. 下载安装微打APP\n2. 使用系统打印功能\n3. 保存图片后用其他方式打印',
                confirmButtonText: '下载微打APP',
                cancelButtonText: '保存图片',
                confirmButtonColor: '#4E89FF'
            }).then(() => {
                // 点击下载
                window.open(downloadUrl, '_blank')
            }).catch(() => {
                // 点击保存图片，关闭弹窗
                this.$toast('请使用下方的"下载图片"按钮保存')
            })
        },

        // 在浏览器中打开微打
        openInBrowser() {
            window.location.href = 'https://detonger.com/WDBQP/'
        },

        // 复制图片到剪贴板
        async copyImageToClipboard() {
            try {
                // 创建临时canvas来转换图片
                const img = new Image()
                img.src = this.previewImageUrl
                await new Promise(resolve => {
                    img.onload = resolve
                })
                
                const canvas = document.createElement('canvas')
                canvas.width = img.width
                canvas.height = img.height
                const ctx = canvas.getContext('2d')
                ctx.drawImage(img, 0, 0)
                
                // 尝试复制到剪贴板
                canvas.toBlob(async blob => {
                    try {
                        await navigator.clipboard.write([
                            new ClipboardItem({ 'image/png': blob })
                        ])
                    } catch (e) {
                        // 部分移动端浏览器不支持图片写入剪贴板，失败时忽略。
                    }
                })
            } catch (e) {
                // 部分移动端浏览器不支持图片写入剪贴板，失败时忽略。
            }
        },

        // 检查是否微信环境
        isWechat() {
            return /MicroMessenger/i.test(navigator.userAgent)
        },

        // 预览图片
        previewImg(img) {
            this.$imagePreview({
                images: this.imgList,
                startPosition: this.imgList.indexOf(img)
            })
        },

        // 生成二维码
        async generateQRCode() {
            const qrKey = this.detail.qrcode_key || this.detail.code
            if (!qrKey) {
                return
            }
            try {
                // 构建详情页URL作为二维码内容，扫码后可跳转
                const currentUrl = window.location.href
                const baseUrl = currentUrl.split('#')[0] + '#/warehouse/detail'
                const params = new URLSearchParams()
                
                if (this.detail.id && this.type) {
                    params.append('type', this.type)
                    params.append('id', this.detail.id)
                }
                params.append('qrcode_key', qrKey)
                
                const detailUrl = `${baseUrl}?${params.toString()}`
                
                this.qrCodeDataUrl = await QRCode.toDataURL(detailUrl, {
                    width: 200,
                    margin: 2,
                    color: {
                        dark: '#000000',
                        light: '#ffffff'
                    }
                })
            } catch (err) {
                console.error('生成二维码失败', err)
                this.$toast('二维码生成失败')
            }
        },

        // 复制文本
        copyText(text) {
            if (!text) return
            until.copyToClipboard(text).then(() => {
                this.$toast('已复制')
            })
        },

        // 查看全部记录
        toAllRecords() {
            this.$router.push({
                path: '/warehouse/record',
                query: { type: this.type, id: this.id }
            })
        },

        // 打开发货弹窗
        openShipment() {
            if (!this.detail || !this.detail.id) {
                this.$toast('请先等待数据加载')
                return
            }
            this.shipmentPreselected = [{
                id: this.detail.id,
                name: this.detail.name,
                code: this.detail.code,
                stock_num: this.detail.stock_num || 0,
                stock_num_info: this.detail.stock_num_info || []
            }]
            this.showShipmentDialog = true
        },

        onShipmentSuccess() {
            // 刷新详情
            this.getDetail()
            this.getStockRecords()
        },

        // ========== 编辑功能 ==========
        // 打开编辑弹窗
        openEdit() {
            if (!this.detail || !this.detail.id) {
                this.$toast('数据加载中，请稍后再试')
                return
            }
            this.editForm = {
                name: this.detail.name || '',
                code: this.detail.code || '',
                intro: this.detail.intro || '',
                purchase_link: this.detail.purchase_link || '',
                purchase_telphone: this.detail.purchase_telphone || ''
            }
            this.editImgList = this.imgList.length > 0 ? [...this.imgList] : []
            this.showEdit = true
        },

        // 触发图片上传
        triggerEditImgUpload() {
            if (this.$refs.editImgInput) {
                this.$refs.editImgInput.click()
            }
        },

        // 选择图片文件
        async handleEditImgSelect(e) {
            const files = Array.from(e.target.files || [])
            if (!files.length) return
            e.target.value = ''

            this.$toast.loading({ message: '上传中...', duration: 0 })
            try {
                await this.getEditAliyunToken()
                for (const file of files) {
                    await this.uploadEditImg(file)
                }
                this.$toast.clear()
                this.$toast.success('上传成功')
            } catch (err) {
                this.$toast.clear()
                console.error('上传失败', err)
                this.$toast('上传失败，请重试')
            }
        },

        // 获取阿里云上传凭证
        async getEditAliyunToken() {
            const res = await studio_api.Teaching_studio_apiMediaAliyunFileUpGet({
                app_id: this.$root.app_id
            })
            if (res.errcode === 0 && res.other) {
                const cfg = JSON.parse(res.other)
                this.uploadConfig = {
                    host: cfg.host,
                    policy: cfg.policy,
                    accessid: cfg.accessid,
                    signature: cfg.signature,
                    dir: cfg.dir
                }
            } else {
                throw new Error('获取上传凭证失败')
            }
        },

        // 上传单张图片到OSS
        uploadEditImg(file) {
            return new Promise((resolve, reject) => {
                if (file.size > 5 * 1024 * 1024) {
                    this.$toast(`${file.name} 超过5MB，已跳过`)
                    resolve()
                    return
                }
                const suffix = file.name.substring(file.name.lastIndexOf('.'))
                const rand = Math.random().toString(36).slice(2, 10)
                const key = `${this.uploadConfig.dir}/${Date.now()}_${rand}${suffix}`
                const formData = new FormData()
                formData.append('key', key)
                formData.append('policy', this.uploadConfig.policy)
                formData.append('OSSAccessKeyId', this.uploadConfig.accessid)
                formData.append('signature', this.uploadConfig.signature)
                formData.append('success_action_status', '200')
                formData.append('file', file)
                fetch(this.uploadConfig.host + '/', { method: 'POST', body: formData })
                    .then(res => {
                        if (res.ok) {
                            this.editImgList.push(this.uploadConfig.host + '/' + key)
                            resolve()
                        } else {
                            reject(new Error('OSS上传失败: ' + res.status))
                        }
                    })
                    .catch(reject)
            })
        },

        // 移除编辑中的图片
        removeEditImg(idx) {
            this.editImgList.splice(idx, 1)
        },

        // 保存编辑
        async saveEdit() {
            if (!this.editForm.name || !this.editForm.name.trim()) {
                this.$toast('请输入名称')
                return
            }
            if (!this.editForm.code || !this.editForm.code.trim()) {
                this.$toast('请输入编码')
                return
            }

            this.editSaving = true
            this.$toast.loading({ message: '保存中...', duration: 0 })

            try {
                const { computer_code, salt } = await getIotmaxFormAuth(studio_tool_api, until)
                const imgsStr = this.editImgList.join(',')

                let res
                if (this.type === 'product') {
                    res = await studio_api.Teaching_studio_apiIotmaxProductUpdatePut({
                        app_id: this.$root.app_id,
                        computer_code,
                        salt,
                        id: this.detail.id,
                        name: this.editForm.name.trim(),
                        code: this.editForm.code.trim(),
                        intro: this.editForm.intro || '',
                        imgs: imgsStr
                    })
                } else {
                    res = await studio_api.Teaching_studio_apiIotmaxMaterialUpdatePut({
                        app_id: this.$root.app_id,
                        computer_code,
                        salt,
                        id: this.detail.id,
                        name: this.editForm.name.trim(),
                        code: this.editForm.code.trim(),
                        intro: this.editForm.intro || '',
                        purchase_link: this.editForm.purchase_link || '',
                        purchase_telphone: this.editForm.purchase_telphone || '',
                        imgs: imgsStr
                    })
                }

                this.$toast.clear()

                if (res.errcode === 0) {
                    this.$toast.success('保存成功')
                    this.showEdit = false
                    // 刷新详情
                    await this.getDetail()
                    this.getStockRecords()
                } else {
                    this.$toast(res.errmsg || '保存失败')
                }
            } catch (err) {
                this.$toast.clear()
                console.error('保存失败', err)
                this.$toast('保存失败，请重试')
            } finally {
                this.editSaving = false
            }
        }
    }
}
</script>

<style scoped>
.stock_detail {
    width: 100%;
    min-height: 100vh;
    background: #F6F6F6;
    padding-bottom: 40px;
    overflow-y: auto;
    max-height: 100vh;
}

.detail_header {
    width: 100%;
    height: 88px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    box-sizing: border-box;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.back_btn i {
    font-size: 40px;
    color: #333;
}

.detail_title {
    font-size: 32px;
    font-weight: bold;
    color: #333;
}

.placeholder {
    width: 40px;
}

.detail_content {
    padding: 20px;
}

.info_card {
    background: #fff;
    border-radius: 16px;
    overflow: hidden;
    margin-bottom: 20px;
}

.info_imgs {
    position: relative;
    height: 400px;
    background: #f5f5f5;
    display: flex;
    align-items: center;
    justify-content: center;
}

.info_imgs .van-swipe {
    height: 100%;
    width: 100%;
}


.info_imgs img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    background: #f5f5f5;
}

.info_imgs .img_error {
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);
    position: relative;
}

.info_imgs .img_error::before {
    content: '无图片';
    color: #999;
    font-size: 28px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.img_tag {
    position: absolute;
    top: 20px;
    right: 20px;
    padding: 8px 20px;
    background: rgba(78, 137, 255, 0.9);
    color: #fff;
    font-size: 24px;
    border-radius: 8px;
}

.info_main {
    padding: 30px;
}

.info_name {
    font-size: 36px;
    font-weight: bold;
    color: #333;
}

.info_code {
    font-size: 26px;
    color: #999;
    margin-top: 12px;
}

.info_stock {
    display: flex;
    align-items: baseline;
    margin-top: 24px;
    padding-top: 24px;
    border-top: 1px solid #f0f0f0;
}

.stock_num .num {
    font-size: 48px;
    font-weight: bold;
    color: #4E89FF;
}

.stock_num .unit {
    font-size: 28px;
    color: #999;
    margin-left: 8px;
}

.stock_label {
    font-size: 26px;
    color: #999;
    margin-left: 16px;
}

/* 各仓库库存明细 */
.warehouse_stock_list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #f0f0f0;
}

.wh_stock_item {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #f5f8ff;
    border: 1px solid rgba(78, 137, 255, 0.15);
    padding: 8px 16px;
    border-radius: 8px;
}

.wh_stock_name {
    font-size: 24px;
    color: #666;
}

.wh_stock_num {
    font-size: 28px;
    font-weight: bold;
    color: #4CAF50;
}

.wh_stock_num.low {
    color: #F44336;
}

.detail_section {
    background: #fff;
    border-radius: 16px;
    padding: 30px;
    margin-bottom: 20px;
}

.section_title {
    font-size: 32px;
    font-weight: bold;
    color: #333;
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.section_title .more {
    font-size: 26px;
    color: #4E89FF;
    font-weight: normal;
}

.section_title .count {
    font-size: 24px;
    color: #999;
    font-weight: normal;
    margin-left: 12px;
}

/* 库存统计 */
.stock_stats {
    padding: 10px 0;
}

.stats_group {
    margin-bottom: 20px;
}

.stats_group:last-child {
    margin-bottom: 0;
}

.group_title {
    font-size: 26px;
    color: #666;
    margin-bottom: 16px;
    font-weight: 500;
}

.stats_grid {
    display: flex;
    justify-content: space-around;
    gap: 20px;
}

.stat_item {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    padding: 20px 10px;
    background: #f9f9f9;
    border-radius: 12px;
}

.stat_value {
    font-size: 36px;
    font-weight: bold;
    margin-bottom: 8px;
}

.stat_value.in {
    color: #4CAF50;
}

.stat_value.out {
    color: #F44336;
}

.stat_value.shipment {
    color: #4E89FF;
}

.stat_label {
    font-size: 24px;
    color: #999;
}

.stats_divider {
    height: 1px;
    background: #f0f0f0;
    margin: 20px 0;
}

/* 关联物料列表 */
.material_list {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.material_item {
    display: flex;
    align-items: center;
    padding: 20px 24px;
    background: #f9f9f9;
    border-radius: 12px;
    cursor: pointer;
}

.material_info {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.material_name {
    font-size: 28px;
    color: #333;
    font-weight: 500;
    flex: 1;
}

.material_num {
    font-size: 26px;
    color: #4E89FF;
    flex-shrink: 0;
}

.material_arrow {
    margin-left: 12px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.info_row {
    display: flex;
    align-items: flex-start;
    padding: 16px 0;
    border-bottom: 1px solid #f5f5f5;
}

.info_row:last-child {
    border-bottom: none;
}

.info_row .label {
    width: 160px;
    font-size: 28px;
    color: #666;
    flex-shrink: 0;
}

.info_row .value {
    flex: 1;
    font-size: 28px;
    color: #333;
    word-break: break-all;
}

.info_row .value.link {
    color: #4E89FF;
}

.info_row i {
    font-size: 32px;
    color: #4E89FF;
    margin-left: 16px;
}

.record_list {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.record_item {
    display: flex;
    align-items: center;
    padding: 20px 24px;
    background: #f9f9f9;
    border-radius: 12px;
}

.record_icon {
    width: 64px;
    height: 64px;
    border-radius: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
}

.record_icon.in {
    background: #E8F5E9;
}

.record_icon.out {
    background: #FFEBEE;
}

.record_icon .van-icon {
    font-size: 32px;
}

.record_info {
    flex: 1;
}

.record_title {
    font-size: 30px;
    color: #333;
}

.record_time {
    font-size: 24px;
    color: #999;
    margin-top: 8px;
}

.record_user {
    font-size: 24px;
    color: #666;
    margin-top: 4px;
}

.record_status {
    font-size: 24px;
    padding: 8px 16px;
    border-radius: 8px;
}

.record_status.status_0 {
    background: #FFF3E0;
    color: #FF9800;
}

.record_status.status_1 {
    background: #E8F5E9;
    color: #4CAF50;
}

.record_status.status_2 {
    background: #FFEBEE;
    color: #F44336;
}

.no_record {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 0;
}

.no_record img {
    width: 200px;
    height: 100px;
    object-fit: contain;
}

.no_record span {
    font-size: 26px;
    color: #999;
    margin-top: 16px;
}

.loading_state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 200px 0;
}

.loading_state span {
    font-size: 28px;
    color: #999;
    margin-top: 20px;
}

/* 二维码区域 */
.qrcode_area {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px;
    background: #f9f9f9;
    border-radius: 12px;
}

.qrcode_img {
    width: 200px;
    height: 200px;
    background: #fff;
    border-radius: 12px;
    padding: 10px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    display: flex;
    align-items: center;
    justify-content: center;
}

.qrcode_img img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.qrcode_img .img_error {
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);
    position: relative;
}

.qrcode_img .img_error::before {
    content: '无图片';
    color: #999;
    font-size: 24px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.qrcode_info {
    margin-top: 20px;
    text-align: center;
}

.qrcode_info .code {
    display: block;
    font-size: 24px;
    color: #666;
    margin-bottom: 8px;
}

.qrcode_info .name {
    display: block;
    font-size: 30px;
    color: #333;
    font-weight: bold;
}

.qrcode_actions {
    margin-top: 24px;
}

/* 打印标签样式 */
.print_label_hidden {
    position: fixed;
    left: -9999px;
    top: 0;
    width: 600px;  /* 必须设置宽度，否则内部百分比/vw单位失效 */
    z-index: -1;
    opacity: 0;
    pointer-events: none;
}

/* 标签预览样式 - 与 StockPrint.vue 保持一致 */
.label_preview {
    width: 100%;
    height: 56.67vw;  /* 60:40 比例 */
    max-width: 600px;
    max-height: 400px;
    background: white;
    border: 2px solid #000;
    position: relative;
    font-family: 'Segoe UI', 'PingFang SC', sans-serif;
    overflow: hidden;
    margin: 0 auto;
}

/* Logo */
.preview_logo {
    position: absolute;
    top: 4%;
    left: 5%;
    height: 100px;
    width: 100px;
    display: flex;
    align-items: center;
}

.preview_logo img {
    height: 100%;
    width: 100%;
    object-fit: contain;
}

/* 类型标签 */
.preview_type {
    position: absolute;
    top: 4%;
    right: 5%;
    font-size: 40px;
    font-weight: 700;
    color: #000;
    background: #fff;
    padding: 1.5vw 3vw;
    border-radius: 4px;
}

/* 分隔线 - 加粗加深以适应黑白打印 */
.preview_divider {
    position: absolute;
    left: 4%;
    right: 4%;
    height: 3px;
    background: #000;
}

.preview_divider.top { top: 30%; }
.preview_divider.bottom { bottom: 12%; }

/* 主体内容 */
.preview_body {
    position: absolute;
    top: 32%;
    left: 5%;
    right: 5%;
    bottom: 18%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.preview_info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 2vw;
    padding-right: 3vw;
    min-width: 0;
}

.preview_name {
    font-weight: 700;
    color: #000;
    line-height: 1.3;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.preview_name.name-large {
    font-size: 7vw;
}

.preview_name.name-medium {
    font-size: 6vw;
}

.preview_name.name-small {
    font-size: 5vw;
}

.preview_name.name-xsmall {
    font-size: 4vw;
}

.preview_code {
    color: #333;
    font-family: 'Courier New', monospace;
    padding: 2px 6px;
    border-radius: 3px;
    font-weight: 700;
    line-height: 1.2;
    word-break: break-all;
    overflow-wrap: break-word;
    max-width: 100%;
}

.preview_code.code-normal {
    font-size: 5vw;
}

.preview_code.code-small {
    font-size: 4.5vw;
}

/* 扫描提示 - 增大字体加深颜色 */
.preview_hint {
    font-size: 4vw;
    color: #000;
    font-weight: 600;
}

/* 二维码 */
.preview_qr {
    width: 30%;
    height: 95%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
    padding: 1vw;
    border-radius: 4px;
    flex-shrink: 0;
    margin-top: 15px;
}

.preview_qr img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

/* 时间 - 增大字体加深颜色 */
.preview_time {
    position: absolute;
    bottom: 0%;
    right: 5%;
    font-size: 5vw;
    color: #000;
    font-family: 'Courier New', monospace;
    font-weight: 700;
    padding: 1vw 2vw;
}

/* 图片预览弹窗样式 */
.image_preview_dialog {
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.image_preview_dialog .preview_title {
    font-size: 32px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
}

.preview_image_container {
    width: 100%;
    background: #f5f5f5;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 200px;
}

.preview_image {
    max-width: 100%;
    max-height: 40vh;
    object-fit: contain;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
    -webkit-touch-callout: default;
}

.preview_image_container .img_error {
    width: 100%;
    height: 40vh;
    background: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);
    position: relative;
    border-radius: 12px;
}

.preview_image_container .img_error::before {
    content: '无图片';
    color: #999;
    font-size: 28px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-user-select: none;
    pointer-events: auto;
}

.preview_tips {
    background: #FFF8E1;
    border-radius: 12px;
    padding: 16px 20px;
    margin-bottom: 20px;
    width: 100%;
}

.preview_tips p {
    font-size: 26px;
    color: #666;
    line-height: 1.8;
    margin: 0;
}

.image_preview_dialog .preview_actions {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.image_preview_dialog .preview_actions .van-button {
   padding: 10px;
}

.ship_action_bar {
    display: flex;
    justify-content: flex-end;
    padding: 12px 0;
    gap: 12px;
}
.ship_action_bar .van-button--default {
    background: #f0f5ff;
    color: #4E89FF;
    border: 1px solid #c8d9ff;
}
.ship_action_bar .van-button--default[disabled] {
    background: #f5f5f5;
    color: #bbb;
    border-color: #e8e8e8;
}

/* 关联物料弹窗 */
.materials_popup {
    padding: 0 0 20px;
}
.materials_popup_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px 16px;
    font-size: 30px;
    font-weight: 600;
    color: #333;
    border-bottom: 1px solid #f0f0f0;
}
.materials_popup_header .van-icon {
    cursor: pointer;
    color: #999;
}
.materials_popup_body {
    padding: 16px 24px;
    max-height: 60vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 12px;
}
.materials_popup_body .material_item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 20px;
    background: #f9f9f9;
    border-radius: 12px;
}
.materials_popup_body .material_item:active {
    background: #f0f0f0;
}
.materials_popup_empty {
    padding: 40px 0;
    text-align: center;
    color: #999;
    font-size: 28px;
}
.header_actions {
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;
    padding: 8px;
}

.edit_popup {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #f6f6f6;
}

.edit_header {
    height: 88px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border-bottom: 1px solid #f0f0f0;
    flex-shrink: 0;
}

.edit_title {
    font-size: 32px;
    font-weight: bold;
    color: #333;
}

.edit_scroll {
    flex: 1;
    overflow-y: auto;
    padding: 20px;
}

.edit_photos {
    background: #fff;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 16px;
}

.photo_label {
    font-size: 28px;
    color: #333;
    font-weight: 500;
    margin-bottom: 16px;
}

.photo_grid {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
}

.photo_item {
    position: relative;
    width: 120px;
    height: 120px;
    border-radius: 10px;
    overflow: hidden;
    background: #f5f5f5;
}

.photo_item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.photo_del {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
}

.photo_add {
    width: 120px;
    height: 120px;
    border: 2px dashed #4E89FF;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    cursor: pointer;
    background: rgba(78,137,255,0.04);
}

.photo_add span {
    font-size: 22px;
    color: #4E89FF;
}

.edit_form {
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 20px;
}

.edit_footer {
    padding: 16px 20px;
    background: #fff;
    flex-shrink: 0;
    box-shadow: 0 -2px 8px rgba(0,0,0,0.05);
}

</style>
